import React from 'react'
import { pdf } from '@react-pdf/renderer'
import isObject from 'lodash/isObject'

export const downloadPdf = async (
  fileUrlOrDocument: string | undefined | React.ReactElement,
  fileName: string | undefined
) => {
  if (!fileUrlOrDocument || !fileName) {
    console.error('File URL or name is missing')
    return
  }

  if (isObject(fileUrlOrDocument)) {
    const docInstance = pdf()
    docInstance.updateContainer(fileUrlOrDocument)
    const blob = await docInstance.toBlob()
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(url)
    return
  }

  const fileUrl = fileUrlOrDocument as string
  try {
    if (fileUrl.startsWith('blob:')) {
      const response = await fetch(fileUrl)
      const blob = await response.blob()
      const newBlob = new Blob([await blob.arrayBuffer()], {
        type: blob.type || 'application/octet-stream'
      })
      const newUrl = URL.createObjectURL(newBlob)
      const a = document.createElement('a')
      a.href = newUrl
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(newUrl)
    } else {
      const blob = new Blob(['This is a sample document.'], { type: 'text/plain' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = fileName
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  } catch (error) {
    console.error('Error creating download:', error)
  }
}
